import { Action } from 'redux';

import { takeEvery, takeLatest, takeLeading } from 'redux-saga/effects';

export enum SagaYieldType {
	Every,
	Latest,
	Leading
}

export interface WatcherSagaYieldStep<T = Action> {
	action: string;
	actionHandler: (action: T) => unknown;
	type: SagaYieldType;
}

export function createWatcherSaga(steps: WatcherSagaYieldStep[]) {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	return function* watchSagas() {
		for (let i = 0; i < steps.length; i += 1) {
			const step = steps[ i ];

			switch (step.type) {
			case SagaYieldType.Every:
				yield takeEvery(step.action, step.actionHandler);
				break;
			case SagaYieldType.Latest:
				yield takeLatest(step.action, step.actionHandler);
				break;
			case SagaYieldType.Leading:
				yield takeLeading(step.action, step.actionHandler);
				break;
			default:
				break;
			}
		}
	};
}
